import ImgVMFC         from "../media/blog/visite-medicale-fin-carriere.webp";
import ImgSPP          from "../media/blog/suivi-post-professionnel-sante-travail.webp";
import ImgAteliers     from "../media/blog/ateliers-visites-fin-mi-carriere-sante-travail.webp";
import ImgTracer       from "../media/blog/tracer-expositions-visite-fin-carriere.webp";
import ImgCNMST1       from "../media/blog/ravail-cnmst-congres-medecine-sante-travail.webp";
import ImgJeuMots      from "../media/blog/ravail-jeu-de-mots-travail-sante.webp";
import ImgChiffres     from "../media/blog/visite-fin-carriere-enjeux-chiffres.webp";
import ImgFrenchTech   from "../media/blog/ravail-la-french-tech-france2030.webp";
import ImgMontpellier  from "../media/blog/ravail-cnmst-2024-montpellier.webp";
import ImgStandB10     from "../media/blog/ravail-cnmst-2024-stand-b10.webp";
import ImgConference   from "../media/blog/conference-dr-quentin-nocture-cnmst-2024.webp";
import ImgRetourImages from "../media/blog/cnmst-2024-retour-images-ravail.gif";
import ImgSlides       from "../media/blog/slides-dr-quentin-nocture-cnmst-2024.webp";
import ImgSport        from "../media/blog/merci-sport-sante-ravail.webp";
import ImgPreconiser   from "../media/blog/vfc-preconiser-suivi-post-professionnel.webp";
import ImgFormations   from "../media/blog/formations-gratuites-ravail-visites-fin-mi-carriere.webp";
import ImgPrix         from "../media/blog/ravail-prix-prevention-talents-e-sante-2024.webp";
import ImgVoeux        from "../media/blog/meilleurs-voeux-2025-ravail-nouveautes.gif";
import ImgInformer     from "../media/blog/visite-fin-carriere-informer-salaries-ravail.webp";
import ImgJBTP         from "../media/blog/retour-jbtp25-ravail-sante-btp.webp";
import ImgJEF          from "../media/blog/ravail-jef-2025-strasbourg-assistant-sante-travail.webp";
import ImgBenefices    from "../media/blog/visite-fin-de-carriere-benefices.webp";
import ImgDefi         from "../media/blog/defi2.webp";
import ImgSimplifie    from "../media/blog/simplifie-la-visite.webp";
import ImgReconstitution from "../media/blog/ravail-reconstitution-dossier-medical.webp";
import ImgJEF2         from "../media/blog/retour-jef-2025-ravail-sante-au-travail.webp";
import ImgJBTP2025     from "../media/blog/ravail-journees-sante-travail-btp-2025.webp";
import ImgVotez        from "../media/blog/votez-ravail-talents-e-sante-2024.webp";
import ImgDecouvrez    from "../media/blog/decouvrez-site-ravail-outils-sante-travail.webp";
import ImgBilan        from "../media/blog/bilan-juin-ravail-cnmst-vfc.webp";
import ImgEasyVFC      from "../media/blog/easyvfc-outil-eligibilite-vfc.gif";
import ImgVoeux2026    from "../media/blog/meilleurs-voeux-2026-ravail.gif";
import ImgCNMSTLyon2026 from "../media/blog/cnmst-lyon-2026.webp";
import ImgRavailEmissionMieuxFranceTv2026 from "../media/blog/emission-mieux-france-tv-2026.webp";

export const CATEGORIE_COLORS = {
  "Événement":           { bg: "rgba(4, 172, 235, 0.12)",   color: "#04aceb" },
  "Médecine du travail": { bg: "rgba(58, 88, 134, 0.10)",   color: "#3a5886" },
  "Innovation":          { bg: "rgba(147, 198, 182, 0.25)", color: "#93c6b6" },
  "Actualité":           { bg: "rgba(249, 176, 117, 0.20)", color: "#f9b075" },
  "Annuaire SPSTI":      { bg: "rgba(46, 160, 120, 0.15)",  color: "#2e9a78" },
};

const ARTICLES_RAW = [
  // ── Annuaire régional & national (drainage SEO) ──────────────────────
  {
    key: "spsti-france",
    image: require('../media/blog/spsti-france.webp'),
    deptNum: "FR",
    deptName: "France entière",
    dateISO: "2026-07-13",
    date: "13 juillet 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en France : annuaire national des SPSTI par région",
    description: "Annuaire national des SPSTI : trouvez le Service de Prévention et de Santé au Travail agréé de votre région et de votre département, partout en France.",
    related: ["spsti-outre-mer", "spsti-region-ile-de-france", "spsti-region-auvergne-rhone-alpes"],
  },
  {
    key: "spsti-outre-mer",
    image: require('../media/blog/spsti-outre-mer.webp'),
    deptNum: "OM",
    deptName: "Outre-mer",
    dateISO: "2026-07-13",
    date: "13 juillet 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Outre-mer : annuaire des SPSTI (DROM)",
    description: "Annuaire des SPSTI en Outre-mer : services de santé au travail agréés en Guadeloupe, Martinique, Guyane, La Réunion et Mayotte, et obligations des employeurs.",
    related: ["spsti-france", "spsti-974-la-reunion", "spsti-971-guadeloupe"],
  },
  {
    key: "spsti-region-auvergne-rhone-alpes",
    image: require('../media/blog/spsti-region-auvergne-rhone-alpes.webp'),
    deptNum: "ARA",
    deptName: "Auvergne-Rhône-Alpes",
    dateISO: "2026-07-13",
    date: "13 juillet 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Auvergne-Rhône-Alpes : annuaire des SPSTI par département",
    description: "Annuaire des SPSTI en Auvergne-Rhône-Alpes : services de santé au travail agréés dans les 12 départements de la région, communes couvertes et obligations des employeurs.",
    related: ["spsti-france", "spsti-69-rhone", "spsti-38-isere"],
  },
  {
    key: "spsti-region-bourgogne-franche-comte",
    image: require('../media/blog/spsti-region-bourgogne-franche-comte.webp'),
    deptNum: "BFC",
    deptName: "Bourgogne-Franche-Comté",
    dateISO: "2026-07-13",
    date: "13 juillet 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Bourgogne-Franche-Comté : annuaire des SPSTI par département",
    description: "SPSTI en Bourgogne-Franche-Comté : trouvez le service de santé au travail agréé de votre département parmi les 8 départements de la région et vos obligations d'employeur.",
    related: ["spsti-france", "spsti-25-doubs", "spsti-21-cote-d-or"],
  },
  {
    key: "spsti-region-bretagne",
    image: require('../media/blog/spsti-region-bretagne.webp'),
    deptNum: "BRE",
    deptName: "Bretagne",
    dateISO: "2026-07-13",
    date: "13 juillet 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Bretagne : annuaire des SPSTI par département",
    description: "Annuaire des SPSTI en Bretagne : services de santé au travail agréés dans les 4 départements bretons, communes couvertes et obligations des employeurs.",
    related: ["spsti-france", "spsti-35-ille-et-vilaine", "spsti-29-finistere"],
  },
  {
    key: "spsti-region-centre-val-de-loire",
    image: require('../media/blog/spsti-region-centre-val-de-loire.webp'),
    deptNum: "CVL",
    deptName: "Centre-Val de Loire",
    dateISO: "2026-07-13",
    date: "13 juillet 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Centre-Val de Loire : annuaire des SPSTI par département",
    description: "SPSTI en Centre-Val de Loire : accédez à l'annuaire des services de santé au travail agréés dans les 6 départements de la région et à vos obligations RH.",
    related: ["spsti-france", "spsti-37-indre-et-loire", "spsti-45-loiret"],
  },
  {
    key: "spsti-region-corse",
    image: require('../media/blog/spsti-region-corse.webp'),
    deptNum: "COR",
    deptName: "Corse",
    dateISO: "2026-07-13",
    date: "13 juillet 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Corse : annuaire des SPSTI par département",
    description: "Annuaire des SPSTI en Corse : services de santé au travail agréés en Corse-du-Sud et Haute-Corse, communes couvertes et obligations des employeurs.",
    related: ["spsti-france", "spsti-2a-corse-du-sud", "spsti-2b-haute-corse"],
  },
  {
    key: "spsti-region-grand-est",
    image: require('../media/blog/spsti-region-grand-est.webp'),
    deptNum: "GES",
    deptName: "Grand Est",
    dateISO: "2026-07-13",
    date: "13 juillet 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans le Grand Est : annuaire des SPSTI par département",
    description: "SPSTI dans le Grand Est : trouvez le service de santé au travail agréé de votre département parmi les 10 départements de la région et vos obligations légales.",
    related: ["spsti-france", "spsti-67-bas-rhin", "spsti-57-moselle"],
  },
  {
    key: "spsti-region-hauts-de-france",
    image: require('../media/blog/spsti-region-hauts-de-france.webp'),
    deptNum: "HDF",
    deptName: "Hauts-de-France",
    dateISO: "2026-07-13",
    date: "13 juillet 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans les Hauts-de-France : annuaire des SPSTI par département",
    description: "Annuaire des SPSTI dans les Hauts-de-France : services de santé au travail agréés dans les 5 départements de la région et obligations des employeurs.",
    related: ["spsti-france", "spsti-59-nord", "spsti-62-pas-de-calais"],
  },
  {
    key: "spsti-region-ile-de-france",
    image: require('../media/blog/spsti-region-ile-de-france.webp'),
    deptNum: "IDF",
    deptName: "Île-de-France",
    dateISO: "2026-07-13",
    date: "13 juillet 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Île-de-France : annuaire des SPSTI par département",
    description: "SPSTI en Île-de-France : accédez à l'annuaire des services de santé au travail agréés à Paris et dans les 8 départements franciliens, et à vos obligations.",
    related: ["spsti-france", "spsti-75-paris", "spsti-92-hauts-de-seine"],
  },
  {
    key: "spsti-region-normandie",
    image: require('../media/blog/spsti-region-normandie.webp'),
    deptNum: "NOR",
    deptName: "Normandie",
    dateISO: "2026-07-13",
    date: "13 juillet 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Normandie : annuaire des SPSTI par département",
    description: "Annuaire des SPSTI en Normandie : services de santé au travail agréés dans les 5 départements normands, communes couvertes et obligations des employeurs.",
    related: ["spsti-france", "spsti-76-seine-maritime", "spsti-14-calvados"],
  },
  {
    key: "spsti-region-nouvelle-aquitaine",
    image: require('../media/blog/spsti-region-nouvelle-aquitaine.webp'),
    deptNum: "NAQ",
    deptName: "Nouvelle-Aquitaine",
    dateISO: "2026-07-13",
    date: "13 juillet 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Nouvelle-Aquitaine : annuaire des SPSTI par département",
    description: "SPSTI en Nouvelle-Aquitaine : trouvez le service de santé au travail agréé de votre département parmi les 12 départements de la région et vos obligations.",
    related: ["spsti-france", "spsti-33-gironde", "spsti-64-pyrenees-atlantiques"],
  },
  {
    key: "spsti-region-occitanie",
    image: require('../media/blog/spsti-region-occitanie.webp'),
    deptNum: "OCC",
    deptName: "Occitanie",
    dateISO: "2026-07-13",
    date: "13 juillet 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Occitanie : annuaire des SPSTI par département",
    description: "Annuaire des SPSTI en Occitanie : services de santé au travail agréés dans les 13 départements de la région, communes couvertes et obligations employeurs.",
    related: ["spsti-france", "spsti-31-haute-garonne", "spsti-34-herault"],
  },
  {
    key: "spsti-region-pays-de-la-loire",
    image: require('../media/blog/spsti-region-pays-de-la-loire.webp'),
    deptNum: "PDL",
    deptName: "Pays de la Loire",
    dateISO: "2026-07-13",
    date: "13 juillet 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Pays de la Loire : annuaire des SPSTI par département",
    description: "SPSTI en Pays de la Loire : accédez à l'annuaire des services de santé au travail agréés dans les 5 départements de la région et à vos obligations RH.",
    related: ["spsti-france", "spsti-44-loire-atlantique", "spsti-49-maine-et-loire"],
  },
  {
    key: "spsti-region-provence-alpes-cote-d-azur",
    image: require('../media/blog/spsti-region-provence-alpes-cote-d-azur.webp'),
    deptNum: "PAC",
    deptName: "Provence-Alpes-Côte d'Azur",
    dateISO: "2026-07-13",
    date: "13 juillet 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Provence-Alpes-Côte d'Azur (PACA) : annuaire des SPSTI",
    description: "Annuaire des SPSTI en Provence-Alpes-Côte d'Azur : services de santé au travail agréés dans les 6 départements de la région PACA et obligations employeurs.",
    related: ["spsti-france", "spsti-13-bouches-du-rhone", "spsti-06-alpes-maritimes"],
  },

  {
    key: "ravail-emission-mieux-france-tv-2026",
    image: ImgRavailEmissionMieuxFranceTv2026,
    dateISO: "2026-05-28",
    date: "28 mai 2026",
    categorie: "Actualité",
    titre: "Replay disponible : l’IA, quel impact sur la santé des consommateurs ?",
    description: "Visionner le replay de l’émission Mieux dans ma boîte consacrée aux impacts de l’intelligence artificielle sur le travail, la santé mentale et les enjeux de prévention.",
  },
  {
    key: "cnmst-lyon-2026",
    image: ImgCNMSTLyon2026,
    dateISO: "2026-04-14",
    date: "14 avril 2026",
    categorie: "Événement",
    titre: "RAVAIL au CNMST 2026 à Lyon — Retrouvez-nous stand C13",
    description: "RAVAIL participe au CNMST 2026 à Lyon, du 2 au 5 juin. Venez nous retrouver stand C13 pour découvrir nos dernières nouveautés.",
  },
  {
    key: "meilleurs-voeux-2026-ravail",
    image: ImgVoeux2026,
    dateISO: "2026-01-09",
    date: "9 janvier 2026",
    categorie: "Actualité",
    titre: "Meilleurs vœux 2026 de toute l'équipe RAVAIL",
    description: "Toute l'équipe RAVAIL vous souhaite une excellente année 2026, pleine de santé et de bonheur.",
  },
  {
    key: "retour-jef-2025-ravail-sante-au-travail",
    image: ImgJEF2,
    dateISO: "2025-07-29",
    date: "29 juillet 2025",
    categorie: "Événement",
    titre: "Retour sur la participation de RAVAIL aux JEF 2025",
    description: "RAVAIL remercie les participants des JEF 2025 pour leur visite sur le stand. Découvrez nos échanges, retours et motivations pour faire évoluer nos solutions santé au travail.",
  },
  {
    key: "retour-jbtp25-ravail-sante-btp",
    image: ImgJBTP,
    dateISO: "2025-07-18",
    date: "18 juillet 2025",
    categorie: "Événement",
    titre: "Retour sur la participation de RAVAIL aux Journées Nationales Santé au Travail BTP",
    description: "RAVAIL remercie tous les participants venus découvrir ses solutions lors des Journées Nationales de Santé au Travail dans le BTP. Découvrez nos souvenirs et échanges du stand.",
  },
  {
    key: "ravail-jef-2025-strasbourg-assistant-sante-travail",
    image: ImgJEF,
    dateISO: "2025-06-20",
    date: "20 juin 2025",
    categorie: "Événement",
    titre: "RAVAIL aux JEF 2025 à Strasbourg : découvrez notre assistant santé au travail",
    description: "RAVAIL participe aux Journées d'Études et de Formation (JEF) 2025 à Strasbourg du 11 au 13 juin. Découvrez notre assistant de consultation et échangez avec notre équipe.",
  },
  {
    key: "ravail-journees-sante-travail-btp-2025",
    image: ImgJBTP2025,
    dateISO: "2025-06-06",
    date: "6 juin 2025",
    categorie: "Événement",
    titre: "RAVAIL aux Journées Nationales de Santé au Travail dans le BTP",
    description: "Rencontrez RAVAIL aux Journées Nationales de Santé au Travail dans le BTP à Tours du 4 au 6 juin. Découvrez notre assistant de consultation et ses nouveautés sur le stand n°5.",
  },
  {
    key: "visite-fin-carriere-importance-ravail",
    image: ImgSimplifie,
    dateISO: "2025-09-17",
    date: "17 septembre 2025",
    categorie: "Médecine du travail",
    titre: "Visite médicale de fin de carrière : l'importance du suivi avec RAVAIL",
    description: "Découvrez pourquoi la visite médicale de fin de carrière est essentielle pour retracer le parcours professionnel, anticiper les risques et renforcer le suivi post-professionnel avec RAVAIL.",
  },
  {
    key: "ravail-reconstitution-dossier-medical",
    image: ImgReconstitution,
    dateISO: "2025-09-24",
    date: "24 septembre 2025",
    categorie: "Innovation",
    titre: "RAVAIL : reconstituer l'historique des dossiers médicaux facilement",
    description: "RAVAIL aide les professionnels de santé au travail à reconstituer l'historique des dossiers médicaux, générer des PDF clairs et sécuriser les informations conformément aux recommandations scientifiques.",
  },
  {
    key: "visite-fin-carriere-informer-salaries-ravail",
    image: ImgInformer,
    dateISO: "2025-02-07",
    date: "7 février 2025",
    categorie: "Médecine du travail",
    titre: "Objectif 3 de la VFC : informer les salariés",
    description: "Découvrez comment la visite médicale de fin de carrière informe les salariés sur la surveillance post-professionnelle et comment RAVAIL facilite cette mission avec ses outils réglementaires.",
    related: ["tracer-expositions-visite-fin-carriere", "vfc-preconiser-suivi-post-professionnel"],
  },
  {
    key: "meilleurs-voeux-2025-ravail-nouveautes",
    image: ImgVoeux,
    dateISO: "2025-01-09",
    date: "9 janvier 2025",
    categorie: "Actualité",
    titre: "Meilleurs vœux 2025 de RAVAIL et nouveautés à venir",
    description: "Toute l'équipe de RAVAIL vous souhaite une excellente année 2025 et vous annonce de nouvelles fonctionnalités et outils innovants en santé au travail.",
  },
  {
    key: "ravail-prix-prevention-talents-e-sante-2024",
    image: ImgPrix,
    dateISO: "2024-12-06",
    date: "6 décembre 2024",
    categorie: "Actualité",
    titre: "RAVAIL remporte le prix Prévention aux Talents de la E-santé 2024",
    description: "RAVAIL est fier de remporter le prix Prévention aux Talents de la E-santé 2024, récompensant ses innovations en médecine du travail et en santé numérique.",
  },
  {
    key: "votez-ravail-talents-e-sante-2024",
    image: ImgVotez,
    dateISO: "2024-11-06",
    date: "6 novembre 2024",
    categorie: "Actualité",
    titre: "Votez pour RAVAIL aux Talents de la E-santé 2024",
    description: "Soutenez RAVAIL et son Assistant médical de visite de santé au travail aux Talents de la E-santé 2024. Votez facilement en ligne et participez à l'innovation en santé au travail.",
  },
  {
    key: "formations-gratuites-ravail-visites-fin-mi-carriere",
    image: ImgFormations,
    dateISO: "2024-08-30",
    date: "30 août 2024",
    categorie: "Événement",
    titre: "Formations gratuites RAVAIL : maîtrisez les visites de fin et mi-carrière",
    description: "Participez aux formations gratuites RAVAIL et découvrez nos assistants médicaux pour gérer efficacement les visites de fin et mi-carrière. Échanges avec nos experts inclus.",
  },
  {
    key: "decouvrez-site-ravail-outils-sante-travail",
    image: ImgDecouvrez,
    dateISO: "2024-08-27",
    date: "27 août 2024",
    categorie: "Innovation",
    titre: "Découvrez le site de RAVAIL : outils et solutions santé au travail",
    description: "Visitez ravail.fr pour découvrir nos outils en ligne, tester l'éligibilité à la visite de fin de carrière, accéder à nos offres et en savoir plus sur notre équipe et nos solutions.",
  },
  {
    key: "vfc-preconiser-suivi-post-professionnel",
    image: ImgPreconiser,
    dateISO: "2024-08-13",
    date: "13 août 2024",
    categorie: "Médecine du travail",
    titre: "Objectif 2 de la VFC : préconiser un suivi post-professionnel",
    description: "Découvrez comment la visite médicale de fin de carrière permet de préconiser un suivi post-professionnel grâce aux recommandations SFST et aux outils RAVAIL.",
    related: ["tracer-expositions-visite-fin-carriere", "visite-fin-carriere-informer-salaries-ravail"],
  },
  {
    key: "slides-dr-quentin-nocture-cnmst-2024",
    image: ImgSlides,
    dateISO: "2024-07-30",
    date: "30 juillet 2024",
    categorie: "Médecine du travail",
    titre: "Slides de la présentation du Dr Quentin Nocture au CNMST 2024",
    description: "Découvrez les slides de la présentation du Dr Quentin Nocture au CNMST 2024 sur les outils innovants pour le suivi post-professionnel et la prévention des expositions professionnelles.",
  },
  {
    key: "merci-sport-sante-ravail",
    image: ImgSport,
    dateISO: "2024-07-27",
    date: "27 juillet 2024",
    categorie: "Actualité",
    titre: "Merci au SPORT : célébrons l'excellence et la santé !",
    description: "Célébrons le sport et son impact sur la santé. Bravo aux athlètes et bénévoles, et découvrez comment le métier de sportif de haut niveau est couvert par les assistants RAVAIL.",
  },
  {
    key: "conference-dr-quentin-nocture-cnmst-2024",
    image: ImgConference,
    dateISO: "2024-07-02",
    date: "2 juillet 2024",
    categorie: "Événement",
    titre: "Conférence Dr Quentin Nocture CNMST 2024 : prévention et suivi post-professionnel",
    description: "Revivez la conférence du Dr Quentin Nocture au CNMST 2024 sur la prévention et le suivi post-professionnel. Découvrez les outils innovants pour optimiser les visites médicales de fin de carrière.",
  },
  {
    key: "bilan-juin-ravail-cnmst-vfc",
    image: ImgBilan,
    dateISO: "2024-06-28",
    date: "28 juin 2024",
    categorie: "Actualité",
    titre: "Bilan du mois de juin : RAVAIL au CNMST et innovations VFC",
    description: "Découvrez le bilan du mois de juin pour RAVAIL : participation au CNMST 2024, lancement de l'outil EasyVFC pour tester l'éligibilité des salariés et optimisation du suivi post-professionnel.",
  },
  {
    key: "reconstituer-histoire-professionnelle-vfc",
    image: ImgDefi,
    dateISO: "2024-06-25",
    date: "25 juin 2024",
    categorie: "Médecine du travail",
    titre: "Reconstituer l'histoire professionnelle : défi clé de la visite de fin de carrière",
    description: "Découvrez comment reconstituer l'histoire professionnelle des salariés pour la visite médicale de fin de carrière grâce à nos outils et matrices exposition-tâches.",
  },
  {
    key: "easyvfc-outil-eligibilite-vfc",
    image: ImgEasyVFC,
    dateISO: "2024-06-13",
    date: "13 juin 2024",
    categorie: "Innovation",
    titre: "EasyVFC : outil gratuit pour identifier l'éligibilité à la visite de fin de carrière",
    description: "Découvrez EasyVFC, l'outil gratuit qui permet au grand public de savoir si ses métiers sont éligibles à la visite médicale de fin de carrière et aux suivis post-professionnels.",
  },
  {
    key: "cnmst-2024-retour-images-ravail",
    image: ImgRetourImages,
    dateISO: "2024-06-11",
    date: "11 juin 2024",
    categorie: "Événement",
    titre: "Retour sur le CNMST 2024 : RAVAIL en images et innovations santé",
    description: "Découvrez le retour en images de la participation de RAVAIL au CNMST 2024. Merci à tous pour vos rencontres et retours enthousiastes sur nos solutions santé au travail.",
  },
  {
    key: "ravail-cnmst-2024-stand-b10",
    image: ImgStandB10,
    dateISO: "2024-06-04",
    date: "4 juin 2024",
    categorie: "Événement",
    titre: "RAVAIL au CNMST 2024 : rendez-vous au stand B-10 pour démos et café",
    description: "Rencontrez RAVAIL au CNMST 2024 à Montpellier ! Retrouvez-nous au stand B-10 pour un café et des démonstrations personnalisées de nos outils santé au travail.",
  },
  {
    key: "ravail-cnmst-2024-montpellier",
    image: ImgMontpellier,
    dateISO: "2024-05-28",
    date: "28 mai 2024",
    categorie: "Événement",
    titre: "RAVAIL au CNMST 2024 : rendez-vous du 4 au 7 juin à Montpellier",
    description: "Rendez-vous au Congrès Médecine et Santé au Travail 2024 avec RAVAIL ! Découvrez nos outils et profitez de démonstrations personnalisées sur le stand B10.",
  },
  {
    key: "ravail-la-french-tech-france2030",
    image: ImgFrenchTech,
    dateISO: "2024-05-23",
    date: "23 mai 2024",
    categorie: "Actualité",
    titre: "RAVAIL rejoint La French Tech et France 2030 : innovation en santé au travail",
    description: "RAVAIL intègre La French Tech et le programme France 2030 pour proposer des assistants médicaux innovants, améliorant le suivi de carrière et la prévention en santé au travail.",
  },
  {
    key: "visite-fin-carriere-enjeux-chiffres",
    image: ImgChiffres,
    dateISO: "2024-05-21",
    date: "21 mai 2024",
    categorie: "Médecine du travail",
    titre: "Visite médicale de fin de carrière : chiffres, enjeux et obstacles",
    description: "Découvrez le nombre de visites médicales de fin de carrière attendues en France, les obstacles à leur réalisation et les enjeux pour salariés et employeurs.",
  },
  {
    key: "ravail-jeu-de-mots-travail-sante",
    image: ImgJeuMots,
    dateISO: "2024-05-16",
    date: "16 mai 2024",
    categorie: "Actualité",
    titre: "RAVAIL : l'histoire derrière le nom et le jeu de mots « Travail Santé »",
    description: "Découvrez pourquoi la marque RAVAIL s'appelle ainsi et comment son nom cache un jeu de mots avec « Travail Santé » pour illustrer notre mission santé au travail.",
  },
  {
    key: "ravail-cnmst-congres-medecine-sante-travail",
    image: ImgCNMST1,
    dateISO: "2024-05-14",
    date: "14 mai 2024",
    categorie: "Événement",
    titre: "RAVAIL au CNMST 2024 : suivi post-professionnel et outils innovants",
    description: "RAVAIL participe au Congrès National de Médecine et Santé au Travail à Montpellier. Découvrez la présentation sur le suivi post-professionnel et les outils innovants.",
  },
  {
    key: "tracer-expositions-visite-fin-carriere",
    image: ImgTracer,
    dateISO: "2024-05-09",
    date: "9 mai 2024",
    categorie: "Médecine du travail",
    titre: "Objectif 1 de la VFC : tracer les expositions professionnelles",
    description: "Lors de la visite médicale de fin de carrière, la traçabilité des expositions professionnelles est essentielle. Méthodes, documents et bonnes pratiques.",
    related: ["vfc-preconiser-suivi-post-professionnel", "visite-fin-carriere-informer-salaries-ravail"],
  },
  {
    key: "ateliers-visites-fin-mi-carriere-sante-travail",
    image: ImgAteliers,
    dateISO: "2024-05-07",
    date: "7 mai 2024",
    categorie: "Événement",
    titre: "Ateliers santé au travail : se former aux visites de fin et mi-carrière",
    description: "Participez aux ateliers santé au travail pour apprendre à gérer les cas complexes de visites de fin et de mi-carrière. Formation gratuite et pratique.",
  },
  {
    key: "suivi-post-professionnel-sante-travail",
    image: ImgSPP,
    dateISO: "2024-05-02",
    date: "2 mai 2024",
    categorie: "Actualité",
    titre: "Suivi post-professionnel en santé au travail : enjeux et mise en place",
    description: "Le suivi post-professionnel permet de surveiller la santé des travailleurs après une exposition aux risques professionnels. Enjeux et mise en place en santé au travail.",
  },
  {
    key: "visite-medicale-fin-carriere",
    image: ImgVMFC,
    dateISO: "2024-04-30",
    date: "30 avril 2024",
    categorie: "Médecine du travail",
    titre: "Visite médicale de fin de carrière (VFC) : obligations et salariés concernés",
    description: "La visite médicale de fin de carrière est obligatoire depuis 2021 pour certains salariés exposés aux risques professionnels. Découvrez qui est concerné et ses objectifs.",
  },
  {
    key: "benefices-visite-fin-carriere-sante-au-travail",
    image: ImgBenefices,
    dateISO: "2025-09-17",
    date: "17 septembre 2025",
    categorie: "Médecine du travail",
    titre: "Visite médicale de fin de carrière : bénéfices pour salariés et médecins",
    description: "Découvrez comment la visite médicale de fin de carrière améliore le suivi post-professionnel, la coordination avec la médecine de ville et les pratiques des médecins du travail.",
  },
  {
    key: "spsti-01-ain",
    image: require('../media/blog/spsti-01-ain.webp'),
    deptNum: "01",
    deptName: "Ain",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans l'Ain (01) : guide et liste des SPSTI",
    description: "Annuaire des SPSTI dans l'Ain (01) : services agréés, communes couvertes, obligations légales et liens vers les agréments officiels.",
  },
  {
    key: "spsti-02-aisne",
    image: require('../media/blog/spsti-02-aisne.webp'),
    deptNum: "02",
    deptName: "Aisne",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI dans l'Aisne (02) : annuaire et adhésion",
    description: "Employeurs dans l'Aisne : trouvez le Service de Prévention et de Santé au Travail compétent, les communes couvertes et vos obligations RH.",
  },
  {
    key: "spsti-03-allier",
    image: require('../media/blog/spsti-03-allier.webp'),
    deptNum: "03",
    deptName: "Allier",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (03) : trouvez votre SPSTI dans l'Allier",
    description: "Liste des centres de médecine du travail dans l'Allier (03), agréments officiels, communes d'intervention et démarches d'adhésion.",
  },
  {
    key: "spsti-04-alpes-de-haute-provence",
    image: require('../media/blog/spsti-04-alpes-de-haute-provence.webp'),
    deptNum: "04",
    deptName: "Alpes-de-Haute-Provence",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre dans les Alpes-de-Haute-Provence (04)",
    description: "SPSTI agréés dans les Alpes-de-Haute-Provence : annuaire complet par commune, agréments officiels et guide des visites médicales obligatoires.",
  },
  {
    key: "spsti-05-hautes-alpes",
    image: require('../media/blog/spsti-05-hautes-alpes.webp'),
    deptNum: "05",
    deptName: "Hautes-Alpes",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans les Hautes-Alpes (05) : liste des SPSTI",
    description: "Trouvez votre Service de Prévention et de Santé au Travail dans les Hautes-Alpes (05) : annuaire, communes et obligations légales des employeurs.",
  },
  {
    key: "spsti-06-alpes-maritimes",
    image: require('../media/blog/spsti-06-alpes-maritimes.webp'),
    deptNum: "06",
    deptName: "Alpes-Maritimes",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans les Alpes-Maritimes (06) : guide et liste des SPSTI",
    description: "Médecine du travail dans les Alpes-Maritimes (06) : annuaire des SPSTI agréés, communes couvertes et adhésion obligatoire pour les employeurs.",
  },
  {
    key: "spsti-07-ardeche",
    image: require('../media/blog/spsti-07-ardeche.webp'),
    deptNum: "07",
    deptName: "Ardèche",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI en Ardèche (07) : annuaire et adhésion",
    description: "Annuaire des SPSTI en Ardèche (07) : services agréés, communes couvertes, obligations légales et liens vers les agréments officiels.",
  },
  {
    key: "spsti-08-ardennes",
    image: require('../media/blog/spsti-08-ardennes.webp'),
    deptNum: "08",
    deptName: "Ardennes",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (08) : trouvez votre SPSTI dans les Ardennes",
    description: "Employeurs dans les Ardennes : trouvez le Service de Prévention et de Santé au Travail compétent, les communes couvertes et vos obligations RH.",
  },
  {
    key: "spsti-09-ariege",
    image: require('../media/blog/spsti-09-ariege.webp'),
    deptNum: "09",
    deptName: "Ariège",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre en Ariège (09)",
    description: "Liste des centres de médecine du travail en Ariège (09), agréments officiels, communes d'intervention et démarches d'adhésion.",
  },
  {
    key: "spsti-10-aube",
    image: require('../media/blog/spsti-10-aube.webp'),
    deptNum: "10",
    deptName: "Aube",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans l'Aube (10) : liste des SPSTI",
    description: "SPSTI agréés dans l'Aube : annuaire complet par commune, agréments officiels et guide des visites médicales obligatoires.",
  },
  {
    key: "spsti-11-aude",
    image: require('../media/blog/spsti-11-aude.webp'),
    deptNum: "11",
    deptName: "Aude",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans l'Aude (11) : guide et liste des SPSTI",
    description: "Trouvez votre Service de Prévention et de Santé au Travail dans l'Aude (11) : annuaire, communes et obligations légales des employeurs.",
  },
  {
    key: "spsti-12-aveyron",
    image: require('../media/blog/spsti-12-aveyron.webp'),
    deptNum: "12",
    deptName: "Aveyron",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI dans l'Aveyron (12) : annuaire et adhésion",
    description: "Médecine du travail dans l'Aveyron (12) : annuaire des SPSTI agréés, communes couvertes et adhésion obligatoire pour les employeurs.",
  },
  {
    key: "spsti-13-bouches-du-rhone",
    image: require('../media/blog/spsti-13-bouches-du-rhone.webp'),
    deptNum: "13",
    deptName: "Bouches-du-Rhône",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (13) : trouvez votre SPSTI dans les Bouches-du-Rhône",
    description: "Annuaire des SPSTI dans les Bouches-du-Rhône (13) : services agréés, communes couvertes, obligations légales et liens vers les agréments officiels.",
  },
  {
    key: "spsti-14-calvados",
    image: require('../media/blog/spsti-14-calvados.webp'),
    deptNum: "14",
    deptName: "Calvados",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre dans le Calvados (14)",
    description: "Employeurs dans le Calvados : trouvez le Service de Prévention et de Santé au Travail compétent, les communes couvertes et vos obligations RH.",
  },
  {
    key: "spsti-15-cantal",
    image: require('../media/blog/spsti-15-cantal.webp'),
    deptNum: "15",
    deptName: "Cantal",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans le Cantal (15) : liste des SPSTI",
    description: "Liste des centres de médecine du travail dans le Cantal (15), agréments officiels, communes d'intervention et démarches d'adhésion.",
  },
  {
    key: "spsti-16-charente",
    image: require('../media/blog/spsti-16-charente.webp'),
    deptNum: "16",
    deptName: "Charente",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Charente (16) : guide et liste des SPSTI",
    description: "SPSTI agréés en Charente : annuaire complet par commune, agréments officiels et guide des visites médicales obligatoires.",
  },
  {
    key: "spsti-17-charente-maritime",
    image: require('../media/blog/spsti-17-charente-maritime.webp'),
    deptNum: "17",
    deptName: "Charente-Maritime",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI en Charente-Maritime (17) : annuaire et adhésion",
    description: "Trouvez votre Service de Prévention et de Santé au Travail en Charente-Maritime (17) : annuaire, communes et obligations légales des employeurs.",
  },
  {
    key: "spsti-18-cher",
    image: require('../media/blog/spsti-18-cher.webp'),
    deptNum: "18",
    deptName: "Cher",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (18) : trouvez votre SPSTI dans le Cher",
    description: "Médecine du travail dans le Cher (18) : annuaire des SPSTI agréés, communes couvertes et adhésion obligatoire pour les employeurs.",
  },
  {
    key: "spsti-19-correze",
    image: require('../media/blog/spsti-19-correze.webp'),
    deptNum: "19",
    deptName: "Corrèze",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre en Corrèze (19)",
    description: "Annuaire des SPSTI en Corrèze (19) : services agréés, communes couvertes, obligations légales et liens vers les agréments officiels.",
  },
  {
    key: "spsti-2a-corse-du-sud",
    image: require('../media/blog/spsti-2a-corse-du-sud.webp'),
    deptNum: "2A",
    deptName: "Corse-du-Sud",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Corse-du-Sud (2A) : liste des SPSTI",
    description: "Employeurs en Corse-du-Sud : trouvez le Service de Prévention et de Santé au Travail compétent, les communes couvertes et vos obligations RH.",
  },
  {
    key: "spsti-2b-haute-corse",
    image: require('../media/blog/spsti-2b-haute-corse.webp'),
    deptNum: "2B",
    deptName: "Haute-Corse",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Haute-Corse (2B) : guide et liste des SPSTI",
    description: "Liste des centres de médecine du travail en Haute-Corse (2B), agréments officiels, communes d'intervention et démarches d'adhésion.",
  },
  {
    key: "spsti-21-cote-d-or",
    image: require('../media/blog/spsti-21-cote-d-or.webp'),
    deptNum: "21",
    deptName: "Côte-d'Or",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI en Côte-d'Or (21) : annuaire et adhésion",
    description: "SPSTI agréés en Côte-d'Or : annuaire complet par commune, agréments officiels et guide des visites médicales obligatoires.",
  },
  {
    key: "spsti-22-cotes-d-armor",
    image: require('../media/blog/spsti-22-cotes-d-armor.webp'),
    deptNum: "22",
    deptName: "Côtes-d'Armor",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (22) : trouvez votre SPSTI dans les Côtes-d'Armor",
    description: "Trouvez votre Service de Prévention et de Santé au Travail dans les Côtes-d'Armor (22) : annuaire, communes et obligations légales des employeurs.",
  },
  {
    key: "spsti-23-creuse",
    image: require('../media/blog/spsti-23-creuse.webp'),
    deptNum: "23",
    deptName: "Creuse",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre en Creuse (23)",
    description: "Médecine du travail en Creuse (23) : annuaire des SPSTI agréés, communes couvertes et adhésion obligatoire pour les employeurs.",
  },
  {
    key: "spsti-24-dordogne",
    image: require('../media/blog/spsti-24-dordogne.webp'),
    deptNum: "24",
    deptName: "Dordogne",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Dordogne (24) : liste des SPSTI",
    description: "Annuaire des SPSTI en Dordogne (24) : services agréés, communes couvertes, obligations légales et liens vers les agréments officiels.",
  },
  {
    key: "spsti-25-doubs",
    image: require('../media/blog/spsti-25-doubs.webp'),
    deptNum: "25",
    deptName: "Doubs",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans le Doubs (25) : guide et liste des SPSTI",
    description: "Employeurs dans le Doubs : trouvez le Service de Prévention et de Santé au Travail compétent, les communes couvertes et vos obligations RH.",
  },
  {
    key: "spsti-26-drome",
    image: require('../media/blog/spsti-26-drome.webp'),
    deptNum: "26",
    deptName: "Drôme",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI dans la Drôme (26) : annuaire et adhésion",
    description: "Liste des centres de médecine du travail dans la Drôme (26), agréments officiels, communes d'intervention et démarches d'adhésion.",
  },
  {
    key: "spsti-27-eure",
    image: require('../media/blog/spsti-27-eure.webp'),
    deptNum: "27",
    deptName: "Eure",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (27) : trouvez votre SPSTI dans l'Eure",
    description: "SPSTI agréés dans l'Eure : annuaire complet par commune, agréments officiels et guide des visites médicales obligatoires.",
  },
  {
    key: "spsti-28-eure-et-loir",
    image: require('../media/blog/spsti-28-eure-et-loir.webp'),
    deptNum: "28",
    deptName: "Eure-et-Loir",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre dans l'Eure-et-Loir (28)",
    description: "Trouvez votre Service de Prévention et de Santé au Travail dans l'Eure-et-Loir (28) : annuaire, communes et obligations légales des employeurs.",
  },
  {
    key: "spsti-29-finistere",
    image: require('../media/blog/spsti-29-finistere.webp'),
    deptNum: "29",
    deptName: "Finistère",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans le Finistère (29) : liste des SPSTI",
    description: "Médecine du travail dans le Finistère (29) : annuaire des SPSTI agréés, communes couvertes et adhésion obligatoire pour les employeurs.",
  },
  {
    key: "spsti-30-gard",
    image: require('../media/blog/spsti-30-gard.webp'),
    deptNum: "30",
    deptName: "Gard",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans le Gard (30) : guide et liste des SPSTI",
    description: "Annuaire des SPSTI dans le Gard (30) : services agréés, communes couvertes, obligations légales et liens vers les agréments officiels.",
  },
  {
    key: "spsti-31-haute-garonne",
    image: require('../media/blog/spsti-31-haute-garonne.webp'),
    deptNum: "31",
    deptName: "Haute-Garonne",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI en Haute-Garonne (31) : annuaire et adhésion",
    description: "Employeurs en Haute-Garonne : trouvez le Service de Prévention et de Santé au Travail compétent, les communes couvertes et vos obligations RH.",
  },
  {
    key: "spsti-32-gers",
    image: require('../media/blog/spsti-32-gers.webp'),
    deptNum: "32",
    deptName: "Gers",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (32) : trouvez votre SPSTI dans le Gers",
    description: "Liste des centres de médecine du travail dans le Gers (32), agréments officiels, communes d'intervention et démarches d'adhésion.",
  },
  {
    key: "spsti-33-gironde",
    image: require('../media/blog/spsti-33-gironde.webp'),
    deptNum: "33",
    deptName: "Gironde",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre en Gironde (33)",
    description: "SPSTI agréés en Gironde : annuaire complet par commune, agréments officiels et guide des visites médicales obligatoires.",
  },
  {
    key: "spsti-34-herault",
    image: require('../media/blog/spsti-34-herault.webp'),
    deptNum: "34",
    deptName: "Hérault",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans l'Hérault (34) : liste des SPSTI",
    description: "Trouvez votre Service de Prévention et de Santé au Travail dans l'Hérault (34) : annuaire, communes et obligations légales des employeurs.",
  },
  {
    key: "spsti-35-ille-et-vilaine",
    image: require('../media/blog/spsti-35-ille-et-vilaine.webp'),
    deptNum: "35",
    deptName: "Ille-et-Vilaine",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Ille-et-Vilaine (35) : guide et liste des SPSTI",
    description: "Médecine du travail en Ille-et-Vilaine (35) : annuaire des SPSTI agréés, communes couvertes et adhésion obligatoire pour les employeurs.",
  },
  {
    key: "spsti-36-indre",
    image: require('../media/blog/spsti-36-indre.webp'),
    deptNum: "36",
    deptName: "Indre",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI dans l'Indre (36) : annuaire et adhésion",
    description: "Annuaire des SPSTI dans l'Indre (36) : services agréés, communes couvertes, obligations légales et liens vers les agréments officiels.",
  },
  {
    key: "spsti-37-indre-et-loire",
    image: require('../media/blog/spsti-37-indre-et-loire.webp'),
    deptNum: "37",
    deptName: "Indre-et-Loire",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (37) : trouvez votre SPSTI en Indre-et-Loire",
    description: "Employeurs en Indre-et-Loire : trouvez le Service de Prévention et de Santé au Travail compétent, les communes couvertes et vos obligations RH.",
  },
  {
    key: "spsti-38-isere",
    image: require('../media/blog/spsti-38-isere.webp'),
    deptNum: "38",
    deptName: "Isère",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre en Isère (38)",
    description: "Liste des centres de médecine du travail en Isère (38), agréments officiels, communes d'intervention et démarches d'adhésion.",
  },
  {
    key: "spsti-39-jura",
    image: require('../media/blog/spsti-39-jura.webp'),
    deptNum: "39",
    deptName: "Jura",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans le Jura (39) : liste des SPSTI",
    description: "SPSTI agréés dans le Jura : annuaire complet par commune, agréments officiels et guide des visites médicales obligatoires.",
  },
  {
    key: "spsti-40-landes",
    image: require('../media/blog/spsti-40-landes.webp'),
    deptNum: "40",
    deptName: "Landes",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans les Landes (40) : guide et liste des SPSTI",
    description: "Trouvez votre Service de Prévention et de Santé au Travail dans les Landes (40) : annuaire, communes et obligations légales des employeurs.",
  },
  {
    key: "spsti-41-loir-et-cher",
    image: require('../media/blog/spsti-41-loir-et-cher.webp'),
    deptNum: "41",
    deptName: "Loir-et-Cher",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI dans le Loir-et-Cher (41) : annuaire et adhésion",
    description: "Médecine du travail dans le Loir-et-Cher (41) : annuaire des SPSTI agréés, communes couvertes et adhésion obligatoire pour les employeurs.",
  },
  {
    key: "spsti-42-loire",
    image: require('../media/blog/spsti-42-loire.webp'),
    deptNum: "42",
    deptName: "Loire",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (42) : trouvez votre SPSTI dans la Loire",
    description: "Annuaire des SPSTI dans la Loire (42) : services agréés, communes couvertes, obligations légales et liens vers les agréments officiels.",
  },
  {
    key: "spsti-43-haute-loire",
    image: require('../media/blog/spsti-43-haute-loire.webp'),
    deptNum: "43",
    deptName: "Haute-Loire",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre en Haute-Loire (43)",
    description: "Employeurs en Haute-Loire : trouvez le Service de Prévention et de Santé au Travail compétent, les communes couvertes et vos obligations RH.",
  },
  {
    key: "spsti-44-loire-atlantique",
    image: require('../media/blog/spsti-44-loire-atlantique.webp'),
    deptNum: "44",
    deptName: "Loire-Atlantique",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Loire-Atlantique (44) : liste des SPSTI",
    description: "Liste des centres de médecine du travail en Loire-Atlantique (44), agréments officiels, communes d'intervention et démarches d'adhésion.",
  },
  {
    key: "spsti-45-loiret",
    image: require('../media/blog/spsti-45-loiret.webp'),
    deptNum: "45",
    deptName: "Loiret",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans le Loiret (45) : guide et liste des SPSTI",
    description: "SPSTI agréés dans le Loiret : annuaire complet par commune, agréments officiels et guide des visites médicales obligatoires.",
  },
  {
    key: "spsti-46-lot",
    image: require('../media/blog/spsti-46-lot.webp'),
    deptNum: "46",
    deptName: "Lot",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI dans le Lot (46) : annuaire et adhésion",
    description: "Trouvez votre Service de Prévention et de Santé au Travail dans le Lot (46) : annuaire, communes et obligations légales des employeurs.",
  },
  {
    key: "spsti-47-lot-et-garonne",
    image: require('../media/blog/spsti-47-lot-et-garonne.webp'),
    deptNum: "47",
    deptName: "Lot-et-Garonne",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (47) : trouvez votre SPSTI dans le Lot-et-Garonne",
    description: "Médecine du travail dans le Lot-et-Garonne (47) : annuaire des SPSTI agréés, communes couvertes et adhésion obligatoire pour les employeurs.",
  },
  {
    key: "spsti-48-lozere",
    image: require('../media/blog/spsti-48-lozere.webp'),
    deptNum: "48",
    deptName: "Lozère",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre en Lozère (48)",
    description: "Annuaire des SPSTI en Lozère (48) : services agréés, communes couvertes, obligations légales et liens vers les agréments officiels.",
  },
  {
    key: "spsti-49-maine-et-loire",
    image: require('../media/blog/spsti-49-maine-et-loire.webp'),
    deptNum: "49",
    deptName: "Maine-et-Loire",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans le Maine-et-Loire (49) : liste des SPSTI",
    description: "Employeurs dans le Maine-et-Loire : trouvez le Service de Prévention et de Santé au Travail compétent, les communes couvertes et vos obligations RH.",
  },
  {
    key: "spsti-50-manche",
    image: require('../media/blog/spsti-50-manche.webp'),
    deptNum: "50",
    deptName: "Manche",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans la Manche (50) : guide et liste des SPSTI",
    description: "Liste des centres de médecine du travail dans la Manche (50), agréments officiels, communes d'intervention et démarches d'adhésion.",
  },
  {
    key: "spsti-51-marne",
    image: require('../media/blog/spsti-51-marne.webp'),
    deptNum: "51",
    deptName: "Marne",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI dans la Marne (51) : annuaire et adhésion",
    description: "SPSTI agréés dans la Marne : annuaire complet par commune, agréments officiels et guide des visites médicales obligatoires.",
  },
  {
    key: "spsti-52-haute-marne",
    image: require('../media/blog/spsti-52-haute-marne.webp'),
    deptNum: "52",
    deptName: "Haute-Marne",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (52) : trouvez votre SPSTI en Haute-Marne",
    description: "Trouvez votre Service de Prévention et de Santé au Travail en Haute-Marne (52) : annuaire, communes et obligations légales des employeurs.",
  },
  {
    key: "spsti-53-mayenne",
    image: require('../media/blog/spsti-53-mayenne.webp'),
    deptNum: "53",
    deptName: "Mayenne",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre en Mayenne (53)",
    description: "Médecine du travail en Mayenne (53) : annuaire des SPSTI agréés, communes couvertes et adhésion obligatoire pour les employeurs.",
  },
  {
    key: "spsti-54-meurthe-et-moselle",
    image: require('../media/blog/spsti-54-meurthe-et-moselle.webp'),
    deptNum: "54",
    deptName: "Meurthe-et-Moselle",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Meurthe-et-Moselle (54) : liste des SPSTI",
    description: "Annuaire des SPSTI en Meurthe-et-Moselle (54) : services agréés, communes couvertes, obligations légales et liens vers les agréments officiels.",
  },
  {
    key: "spsti-55-meuse",
    image: require('../media/blog/spsti-55-meuse.webp'),
    deptNum: "55",
    deptName: "Meuse",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans la Meuse (55) : guide et liste des SPSTI",
    description: "Employeurs dans la Meuse : trouvez le Service de Prévention et de Santé au Travail compétent, les communes couvertes et vos obligations RH.",
  },
  {
    key: "spsti-56-morbihan",
    image: require('../media/blog/spsti-56-morbihan.webp'),
    deptNum: "56",
    deptName: "Morbihan",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI dans le Morbihan (56) : annuaire et adhésion",
    description: "Liste des centres de médecine du travail dans le Morbihan (56), agréments officiels, communes d'intervention et démarches d'adhésion.",
  },
  {
    key: "spsti-57-moselle",
    image: require('../media/blog/spsti-57-moselle.webp'),
    deptNum: "57",
    deptName: "Moselle",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (57) : trouvez votre SPSTI en Moselle",
    description: "SPSTI agréés en Moselle : annuaire complet par commune, agréments officiels et guide des visites médicales obligatoires.",
  },
  {
    key: "spsti-58-nievre",
    image: require('../media/blog/spsti-58-nievre.webp'),
    deptNum: "58",
    deptName: "Nièvre",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre dans la Nièvre (58)",
    description: "Trouvez votre Service de Prévention et de Santé au Travail dans la Nièvre (58) : annuaire, communes et obligations légales des employeurs.",
  },
  {
    key: "spsti-59-nord",
    image: require('../media/blog/spsti-59-nord.webp'),
    deptNum: "59",
    deptName: "Nord",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans le Nord (59) : liste des SPSTI",
    description: "Médecine du travail dans le Nord (59) : annuaire des SPSTI agréés, communes couvertes et adhésion obligatoire pour les employeurs.",
  },
  {
    key: "spsti-60-oise",
    image: require('../media/blog/spsti-60-oise.webp'),
    deptNum: "60",
    deptName: "Oise",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans l'Oise (60) : guide et liste des SPSTI",
    description: "Annuaire des SPSTI dans l'Oise (60) : services agréés, communes couvertes, obligations légales et liens vers les agréments officiels.",
  },
  {
    key: "spsti-61-orne",
    image: require('../media/blog/spsti-61-orne.webp'),
    deptNum: "61",
    deptName: "Orne",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI dans l'Orne (61) : annuaire et adhésion",
    description: "Employeurs dans l'Orne : trouvez le Service de Prévention et de Santé au Travail compétent, les communes couvertes et vos obligations RH.",
  },
  {
    key: "spsti-62-pas-de-calais",
    image: require('../media/blog/spsti-62-pas-de-calais.webp'),
    deptNum: "62",
    deptName: "Pas-de-Calais",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (62) : trouvez votre SPSTI dans le Pas-de-Calais",
    description: "Liste des centres de médecine du travail dans le Pas-de-Calais (62), agréments officiels, communes d'intervention et démarches d'adhésion.",
  },
  {
    key: "spsti-63-puy-de-dome",
    image: require('../media/blog/spsti-63-puy-de-dome.webp'),
    deptNum: "63",
    deptName: "Puy-de-Dôme",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre dans le Puy-de-Dôme (63)",
    description: "SPSTI agréés dans le Puy-de-Dôme : annuaire complet par commune, agréments officiels et guide des visites médicales obligatoires.",
  },
  {
    key: "spsti-64-pyrenees-atlantiques",
    image: require('../media/blog/spsti-64-pyrenees-atlantiques.webp'),
    deptNum: "64",
    deptName: "Pyrénées-Atlantiques",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans les Pyrénées-Atlantiques (64) : liste des SPSTI",
    description: "Trouvez votre Service de Prévention et de Santé au Travail dans les Pyrénées-Atlantiques (64) : annuaire, communes et obligations légales des employeurs.",
  },
  {
    key: "spsti-65-hautes-pyrenees",
    image: require('../media/blog/spsti-65-hautes-pyrenees.webp'),
    deptNum: "65",
    deptName: "Hautes-Pyrénées",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans les Hautes-Pyrénées (65) : guide et liste des SPSTI",
    description: "Médecine du travail dans les Hautes-Pyrénées (65) : annuaire des SPSTI agréés, communes couvertes et adhésion obligatoire pour les employeurs.",
  },
  {
    key: "spsti-66-pyrenees-orientales",
    image: require('../media/blog/spsti-66-pyrenees-orientales.webp'),
    deptNum: "66",
    deptName: "Pyrénées-Orientales",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI dans les Pyrénées-Orientales (66) : annuaire et adhésion",
    description: "Annuaire des SPSTI dans les Pyrénées-Orientales (66) : services agréés, communes couvertes, obligations légales et liens vers les agréments officiels.",
  },
  {
    key: "spsti-67-bas-rhin",
    image: require('../media/blog/spsti-67-bas-rhin.webp'),
    deptNum: "67",
    deptName: "Bas-Rhin",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (67) : trouvez votre SPSTI dans le Bas-Rhin",
    description: "Employeurs dans le Bas-Rhin : trouvez le Service de Prévention et de Santé au Travail compétent, les communes couvertes et vos obligations RH.",
  },
  {
    key: "spsti-68-haut-rhin",
    image: require('../media/blog/spsti-68-haut-rhin.webp'),
    deptNum: "68",
    deptName: "Haut-Rhin",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre dans le Haut-Rhin (68)",
    description: "Liste des centres de médecine du travail dans le Haut-Rhin (68), agréments officiels, communes d'intervention et démarches d'adhésion.",
  },
  {
    key: "spsti-69-rhone",
    image: require('../media/blog/spsti-69-rhone.webp'),
    deptNum: "69",
    deptName: "Rhône",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans le Rhône (69) : liste des SPSTI",
    description: "SPSTI agréés dans le Rhône : annuaire complet par commune, agréments officiels et guide des visites médicales obligatoires.",
  },
  {
    key: "spsti-70-haute-saone",
    image: require('../media/blog/spsti-70-haute-saone.webp'),
    deptNum: "70",
    deptName: "Haute-Saône",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Haute-Saône (70) : guide et liste des SPSTI",
    description: "Trouvez votre Service de Prévention et de Santé au Travail en Haute-Saône (70) : annuaire, communes et obligations légales des employeurs.",
  },
  {
    key: "spsti-71-saone-et-loire",
    image: require('../media/blog/spsti-71-saone-et-loire.webp'),
    deptNum: "71",
    deptName: "Saône-et-Loire",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI en Saône-et-Loire (71) : annuaire et adhésion",
    description: "Médecine du travail en Saône-et-Loire (71) : annuaire des SPSTI agréés, communes couvertes et adhésion obligatoire pour les employeurs.",
  },
  {
    key: "spsti-72-sarthe",
    image: require('../media/blog/spsti-72-sarthe.webp'),
    deptNum: "72",
    deptName: "Sarthe",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (72) : trouvez votre SPSTI en Sarthe",
    description: "Annuaire des SPSTI en Sarthe (72) : services agréés, communes couvertes, obligations légales et liens vers les agréments officiels.",
  },
  {
    key: "spsti-73-savoie",
    image: require('../media/blog/spsti-73-savoie.webp'),
    deptNum: "73",
    deptName: "Savoie",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre en Savoie (73)",
    description: "Employeurs en Savoie : trouvez le Service de Prévention et de Santé au Travail compétent, les communes couvertes et vos obligations RH.",
  },
  {
    key: "spsti-74-haute-savoie",
    image: require('../media/blog/spsti-74-haute-savoie.webp'),
    deptNum: "74",
    deptName: "Haute-Savoie",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Haute-Savoie (74) : liste des SPSTI",
    description: "Liste des centres de médecine du travail en Haute-Savoie (74), agréments officiels, communes d'intervention et démarches d'adhésion.",
  },
  {
    key: "spsti-75-paris",
    image: require('../media/blog/spsti-75-paris.webp'),
    deptNum: "75",
    deptName: "Paris",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail à Paris (75) : guide et liste des SPSTI",
    description: "SPSTI agréés à Paris : annuaire complet par commune, agréments officiels et guide des visites médicales obligatoires.",
  },
  {
    key: "spsti-76-seine-maritime",
    image: require('../media/blog/spsti-76-seine-maritime.webp'),
    deptNum: "76",
    deptName: "Seine-Maritime",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI en Seine-Maritime (76) : annuaire et adhésion",
    description: "Trouvez votre Service de Prévention et de Santé au Travail en Seine-Maritime (76) : annuaire, communes et obligations légales des employeurs.",
  },
  {
    key: "spsti-77-seine-et-marne",
    image: require('../media/blog/spsti-77-seine-et-marne.webp'),
    deptNum: "77",
    deptName: "Seine-et-Marne",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (77) : trouvez votre SPSTI en Seine-et-Marne",
    description: "Médecine du travail en Seine-et-Marne (77) : annuaire des SPSTI agréés, communes couvertes et adhésion obligatoire pour les employeurs.",
  },
  {
    key: "spsti-78-yvelines",
    image: require('../media/blog/spsti-78-yvelines.webp'),
    deptNum: "78",
    deptName: "Yvelines",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre dans les Yvelines (78)",
    description: "Annuaire des SPSTI dans les Yvelines (78) : services agréés, communes couvertes, obligations légales et liens vers les agréments officiels.",
  },
  {
    key: "spsti-79-deux-sevres",
    image: require('../media/blog/spsti-79-deux-sevres.webp'),
    deptNum: "79",
    deptName: "Deux-Sèvres",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans les Deux-Sèvres (79) : liste des SPSTI",
    description: "Employeurs dans les Deux-Sèvres : trouvez le Service de Prévention et de Santé au Travail compétent, les communes couvertes et vos obligations RH.",
  },
  {
    key: "spsti-80-somme",
    image: require('../media/blog/spsti-80-somme.webp'),
    deptNum: "80",
    deptName: "Somme",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans la Somme (80) : guide et liste des SPSTI",
    description: "Liste des centres de médecine du travail dans la Somme (80), agréments officiels, communes d'intervention et démarches d'adhésion.",
  },
  {
    key: "spsti-81-tarn",
    image: require('../media/blog/spsti-81-tarn.webp'),
    deptNum: "81",
    deptName: "Tarn",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI dans le Tarn (81) : annuaire et adhésion",
    description: "SPSTI agréés dans le Tarn : annuaire complet par commune, agréments officiels et guide des visites médicales obligatoires.",
  },
  {
    key: "spsti-82-tarn-et-garonne",
    image: require('../media/blog/spsti-82-tarn-et-garonne.webp'),
    deptNum: "82",
    deptName: "Tarn-et-Garonne",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (82) : trouvez votre SPSTI dans le Tarn-et-Garonne",
    description: "Trouvez votre Service de Prévention et de Santé au Travail dans le Tarn-et-Garonne (82) : annuaire, communes et obligations légales des employeurs.",
  },
  {
    key: "spsti-83-var",
    image: require('../media/blog/spsti-83-var.webp'),
    deptNum: "83",
    deptName: "Var",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre dans le Var (83)",
    description: "Médecine du travail dans le Var (83) : annuaire des SPSTI agréés, communes couvertes et adhésion obligatoire pour les employeurs.",
  },
  {
    key: "spsti-84-vaucluse",
    image: require('../media/blog/spsti-84-vaucluse.webp'),
    deptNum: "84",
    deptName: "Vaucluse",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans le Vaucluse (84) : liste des SPSTI",
    description: "Annuaire des SPSTI dans le Vaucluse (84) : services agréés, communes couvertes, obligations légales et liens vers les agréments officiels.",
  },
  {
    key: "spsti-85-vendee",
    image: require('../media/blog/spsti-85-vendee.webp'),
    deptNum: "85",
    deptName: "Vendée",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail en Vendée (85) : guide et liste des SPSTI",
    description: "Employeurs en Vendée : trouvez le Service de Prévention et de Santé au Travail compétent, les communes couvertes et vos obligations RH.",
  },
  {
    key: "spsti-86-vienne",
    image: require('../media/blog/spsti-86-vienne.webp'),
    deptNum: "86",
    deptName: "Vienne",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI dans la Vienne (86) : annuaire et adhésion",
    description: "Liste des centres de médecine du travail dans la Vienne (86), agréments officiels, communes d'intervention et démarches d'adhésion.",
  },
  {
    key: "spsti-87-haute-vienne",
    image: require('../media/blog/spsti-87-haute-vienne.webp'),
    deptNum: "87",
    deptName: "Haute-Vienne",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (87) : trouvez votre SPSTI en Haute-Vienne",
    description: "SPSTI agréés en Haute-Vienne : annuaire complet par commune, agréments officiels et guide des visites médicales obligatoires.",
  },
  {
    key: "spsti-88-vosges",
    image: require('../media/blog/spsti-88-vosges.webp'),
    deptNum: "88",
    deptName: "Vosges",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre dans les Vosges (88)",
    description: "Trouvez votre Service de Prévention et de Santé au Travail dans les Vosges (88) : annuaire, communes et obligations légales des employeurs.",
  },
  {
    key: "spsti-89-yonne",
    image: require('../media/blog/spsti-89-yonne.webp'),
    deptNum: "89",
    deptName: "Yonne",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans l'Yonne (89) : liste des SPSTI",
    description: "Médecine du travail dans l'Yonne (89) : annuaire des SPSTI agréés, communes couvertes et adhésion obligatoire pour les employeurs.",
  },
  {
    key: "spsti-90-territoire-de-belfort",
    image: require('../media/blog/spsti-90-territoire-de-belfort.webp'),
    deptNum: "90",
    deptName: "Territoire de Belfort",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans le Territoire de Belfort (90) : guide et liste des SPSTI",
    description: "Annuaire des SPSTI dans le Territoire de Belfort (90) : services agréés, communes couvertes, obligations légales et liens vers les agréments officiels.",
  },
  {
    key: "spsti-91-essonne",
    image: require('../media/blog/spsti-91-essonne.webp'),
    deptNum: "91",
    deptName: "Essonne",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI en Essonne (91) : annuaire et adhésion",
    description: "Employeurs en Essonne : trouvez le Service de Prévention et de Santé au Travail compétent, les communes couvertes et vos obligations RH.",
  },
  {
    key: "spsti-92-hauts-de-seine",
    image: require('../media/blog/spsti-92-hauts-de-seine.webp'),
    deptNum: "92",
    deptName: "Hauts-de-Seine",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (92) : trouvez votre SPSTI dans les Hauts-de-Seine",
    description: "Liste des centres de médecine du travail dans les Hauts-de-Seine (92), agréments officiels, communes d'intervention et démarches d'adhésion.",
  },
  {
    key: "spsti-93-seine-saint-denis",
    image: require('../media/blog/spsti-93-seine-saint-denis.webp'),
    deptNum: "93",
    deptName: "Seine-Saint-Denis",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre en Seine-Saint-Denis (93)",
    description: "SPSTI agréés en Seine-Saint-Denis : annuaire complet par commune, agréments officiels et guide des visites médicales obligatoires.",
  },
  {
    key: "spsti-94-val-de-marne",
    image: require('../media/blog/spsti-94-val-de-marne.webp'),
    deptNum: "94",
    deptName: "Val-de-Marne",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans le Val-de-Marne (94) : liste des SPSTI",
    description: "Trouvez votre Service de Prévention et de Santé au Travail dans le Val-de-Marne (94) : annuaire, communes et obligations légales des employeurs.",
  },
  {
    key: "spsti-95-val-d-oise",
    image: require('../media/blog/spsti-95-val-d-oise.webp'),
    deptNum: "95",
    deptName: "Val-d'Oise",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail dans le Val-d'Oise (95) : guide et liste des SPSTI",
    description: "Médecine du travail dans le Val-d'Oise (95) : annuaire des SPSTI agréés, communes couvertes et adhésion obligatoire pour les employeurs.",
  },
  {
    key: "spsti-971-guadeloupe",
    image: require('../media/blog/spsti-971-guadeloupe.webp'),
    deptNum: "971",
    deptName: "Guadeloupe",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "SPSTI en Guadeloupe (971) : annuaire et adhésion",
    description: "Annuaire des SPSTI en Guadeloupe (971) : services agréés, communes couvertes, obligations légales et liens vers les agréments officiels.",
  },
  {
    key: "spsti-972-martinique",
    image: require('../media/blog/spsti-972-martinique.webp'),
    deptNum: "972",
    deptName: "Martinique",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail (972) : trouvez votre SPSTI en Martinique",
    description: "Employeurs en Martinique : trouvez le Service de Prévention et de Santé au Travail compétent, les communes couvertes et vos obligations RH.",
  },
  {
    key: "spsti-973-guyane",
    image: require('../media/blog/spsti-973-guyane.webp'),
    deptNum: "973",
    deptName: "Guyane",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Médecine du travail : trouver son centre en Guyane (973)",
    description: "Liste des centres de médecine du travail en Guyane (973), agréments officiels, communes d'intervention et démarches d'adhésion.",
  },
  {
    key: "spsti-974-la-reunion",
    image: require('../media/blog/spsti-974-la-reunion.webp'),
    deptNum: "974",
    deptName: "La Réunion",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail à La Réunion (974) : liste des SPSTI",
    description: "SPSTI agréés à La Réunion : annuaire complet par commune, agréments officiels et guide des visites médicales obligatoires.",
  },
  {
    key: "spsti-976-mayotte",
    image: require('../media/blog/spsti-976-mayotte.webp'),
    deptNum: "976",
    deptName: "Mayotte",
    dateISO: "2026-05-14",
    date: "14 mai 2026",
    categorie: "Annuaire SPSTI",
    titre: "Santé au travail à Mayotte (976) : guide et liste des SPSTI",
    description: "Trouvez votre Service de Prévention et de Santé au Travail à Mayotte (976) : annuaire, communes et obligations légales des employeurs.",
  }

];

const TODAY_ISO = "2026-05-19";
const TODAY_LABEL = "19 mai 2026";

const ARTICLES_WITH_UPDATE = ARTICLES_RAW.map((a) => {
  const isAnnuaire = a.categorie === "Annuaire SPSTI";
  return {
    ...a,
    updatedISO: isAnnuaire ? a.dateISO : TODAY_ISO,
    updated: isAnnuaire ? a.date : TODAY_LABEL,
  };
});

export const ARTICLES = ARTICLES_WITH_UPDATE.sort((a, b) => {
  if (!a.updatedISO) return 1;
  if (!b.updatedISO) return -1;
  const byUpdated = b.updatedISO.localeCompare(a.updatedISO);
  if (byUpdated !== 0) return byUpdated;
  // Égalité de date de mise à jour : on départage par date de publication
  if (!a.dateISO) return 1;
  if (!b.dateISO) return -1;
  return b.dateISO.localeCompare(a.dateISO);
});

export const IMAGES_BY_SLUG = Object.fromEntries(
  ARTICLES.map((a) => [a.key, a.image])
);
